import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'DATECONVERT',
  category: FunctionCategory.TIMESTAMP,
  description:
    'Converts strings to dates according to the specified pattern, using available time unit specifiers',
  shortDescription: 'Converts strings to dates/timestamps',
  params: [
    {
      name: 'date string',
      type: ArgType.text,
      description: 'The date in string form (example: "1992-03-02").',
    },
    {
      name: 'format string',
      type: ArgType.text,
      description: 'The specified date format (example: "%Y-%m-%d").',
    },
  ],
} satisfies AnalysisFunction;
